var map = {
	"./area_1.svg": "8fe4",
	"./area_15.svg": "c184",
	"./area_16.svg": "c4ac",
	"./area_17.svg": "4c62",
	"./area_18.svg": "5596",
	"./area_19.svg": "2989",
	"./area_2.svg": "b8b2",
	"./area_22.svg": "62ec",
	"./area_23.svg": "5408",
	"./area_24.svg": "0f1f",
	"./area_25.svg": "8ca7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "18bf";